import { render, staticRenderFns } from "./BrandIcon.vue?vue&type=template&id=ce1b1724&scoped=true&"
import script from "./BrandIcon.vue?vue&type=script&lang=js&"
export * from "./BrandIcon.vue?vue&type=script&lang=js&"
import style0 from "./BrandIcon.vue?vue&type=style&index=0&id=ce1b1724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1b1724",
  null
  
)

export default component.exports